import React from "react";

interface HelpTextProps {
  children: React.ReactNode;
  className?: string;
}

export function HelpText({ children, className }: HelpTextProps) {
  return (
    <span className={`cy:text-base cy:italic cy:text-foreground cy:font-normal cy:my-1 cy:block${className ? ` ${className}` : ''}`}>
      {children}
    </span>
  );
} 